import * as z from "zod/v4";

export const getConsolidationInvoicePdf = {
  name: "getConsolidationInvoicePdf" as const,
  input: z.object({ fulfillmentGroupId: z.string() }),
  output: z.object({ url: z.string() }),
};
